var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.effectType === 'currency')?_c('span',[_vm._v("+"+_vm._s(_vm.$formatNum(_vm.value))+" "+_vm._s(_vm.$vuetify.lang.t(`$vuetify.currency.${_vm.effectName}.name`)))]):(_vm.effectType === 'consumable')?_c('span',[_vm._v("+"+_vm._s(_vm.$formatNum(_vm.value))+" "+_vm._s(_vm.$vuetify.lang.t(`$vuetify.consumable.${_vm.effectName}.name`)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }